// extracted by mini-css-extract-plugin
export default {"containerCafeteria":"cafeteria_containerCafeteria__f-x9a"};